import c1 from "assets/images/posts/c1.jpg";
import c2 from "assets/images/posts/c2.jpg";
import c3 from "assets/images/posts/c3.jpg";
import c4 from "assets/images/posts/c4.jpg";
import PostImage from "./PostImage";

const PostMedia4 = () => {
    return (
        <div className="post-image quad-img">
            <div className="masonry-grid justify-center gap-5">
                {/* <!-- Left column --> */}
                <div
                    className="masonry-column-left flex flex-col justify-center gap-5"
                    style={{ width: "45%" }}
                >
                    {/* <div className=" ">
                        <img src={c1} alt="" />
                    </div> */}
                    <PostImage img={c1} style={{ height: "47%" }} />
                    {/* <div className=" ">
                        <img src={c2} alt="" />
                    </div> */}
                    <PostImage img={c2} style={{ height: "47%" }} />
                </div>
                {/* <!-- Right column --> */}
                <div
                    className="masonry-column-right flex flex-col justify-center gap-5"
                    style={{ width: "45%" }}
                >
                    {/* <div className=" ">
                        <img src={c3} alt="" />
                    </div> */}
                    <PostImage img={c3} style={{ height: "47%" }} />
                    {/* <div className=" ">
                        <img src={c4} alt="" />
                    </div> */}
                    <PostImage img={c4} style={{ height: "47%" }} />
                </div>
            </div>
        </div>
    );
};

export default PostMedia4;
